
import {Vue, Component} from 'vue-property-decorator';
import {getSuppliersList} from "@/api/inquiry";
import EditPackage from "@/views-oms/customer-package-management/components/editPackage.vue";
import {
  deletePackaging, downloadInfo,
  downloadTemplate,
  pageQueryPackagingByBrand, purgeAllPackagingByBrand,
  uploadCustomerPackage
} from "@/api/customer-package";
import Pagination from "@/components/Pagination/index.vue";
import {Message} from "element-ui";
import {deepClone} from "@/utils/deepClone";

@Component({
  name: "customerBrandPackageList",
  components: {Pagination, EditPackage}
})
export default class extends Vue {
  private containerLoading = false;
  private headerInfo = {
    customer: "",
    brandId: "",
    brand: "",
  };
  private searchParams = {
    inquiryRefNumber: "",
    supplier: "",
    supplierOptions: [],
  };
  private queryList = [];
  private tableData = [];
  private page = {
    pageNumber: 1,
    pageSize: 20,
    total: 0,
  };
  private files: any[] = [];
  private isFirstActivated = true;

  created() {
    this.initHeaderInfoFromRoute();
    this.getList();
  }

  activated() {
    if (this.isFirstActivated) {
      this.isFirstActivated = false;
      return;
    }
    this.initHeaderInfoFromRoute();
    this.getList();
  }

  private initHeaderInfoFromRoute() {
    const item = this.$route.query.item as string;
    if (!item) {
      return;
    }
    const json = decodeURIComponent(item);
    const data = JSON.parse(json);
    this.headerInfo.customer = data.customer;
    this.headerInfo.brandId = data.brandId;
    this.headerInfo.brand = data.brand;
  }

  private async searchSupplier(query) {
    this.searchParams.supplierOptions = await getSuppliersList({abbreviation: query}) as any;
  }

  private async getList() {
    const params = {
      pageNumber: this.page.pageNumber,
      pageSize: this.page.pageSize,
      brandId: this.headerInfo.brandId,
      inquiryRefNumber: this.searchParams.inquiryRefNumber,
      supplier: this.searchParams.supplier,
    }
    const res = await pageQueryPackagingByBrand(params) as any;
    this.queryList = res.list;
    this.tableData = this.handleTableData(this.queryList);
    this.page.total = Number(res.total);
  }

  private handleTableData(list) {
    const tableData = [];
    for (const item of list) {
      const id = item.id;
      const hqProductName = item.hqProductName;
      const inquiryRefType = item.inquiryRefType;
      const inquiryRefNumber = item.inquiryRefNumber;
      const supplierAbbr = item.supplierAbbr;

      const innerBagLength = item.innerBag.details?.length || 1;
      const innerBoxLength = item.innerBox.details?.length || 1;
      const rowCount = Math.max(innerBagLength, innerBoxLength);
      const max = rowCount;
      const min = Math.min(innerBagLength, innerBoxLength);
      const lineMerge = Math.floor(Number((max / min).toFixed(2)));
      let lastLineMergeMore = max % min;
      let maxPackage;
      if (innerBagLength > innerBoxLength) {
        maxPackage = "bag";
      } else {
        maxPackage = "box";
      }
      let needMergeIndex = 0;
      let index = -1;
      for (let i = 0; i < rowCount; i++) {
        let merge = 0;
        if (needMergeIndex === i) {
          if (lastLineMergeMore !== 0) {
            merge = lineMerge + 1;
            lastLineMergeMore = lastLineMergeMore - 1;
          } else {
            merge = lineMerge;
          }
          needMergeIndex = needMergeIndex + merge;
        }
        if (merge !== 0) {
          index++;
        }
        const bagIndex = maxPackage === "bag"? i : index;
        const boxIndex = maxPackage === "box"? i : index;
        const baseMerge = i === 0? rowCount : 0;
        let bagMerge;
        let boxMerge;
        if (maxPackage === "bag") {
          bagMerge = 1;
        } else {
          bagMerge = merge;
        }
        if (maxPackage === "box") {
          boxMerge = 1;
        } else {
          boxMerge = merge;
        }
        const innerBagDetail = item.innerBag.details && item.innerBag.details.length > 0? item.innerBag.details[bagIndex] : {};
        const innerBoxDetail = item.innerBox.details && item.innerBox.details.length > 0? item.innerBox.details[boxIndex] : {};
        const data = {
          id: id,
          hqName: hqProductName,
          codeType: inquiryRefType,
          code: inquiryRefNumber,
          supplier: supplierAbbr,
          bagMethod: item.innerBag.desc,
          bagProvider: item.innerBag.provider,
          bagQty: item.innerBag.itemsPerPack,
          bagNeutralSize: innerBagDetail.supplierDimension,
          bagUseSize: innerBagDetail.actualDimension,
          bagCode: innerBagDetail.code,
          bagName: innerBagDetail.name,
          bagSpec: innerBagDetail.specification,
          bagPrice: innerBagDetail.unitPrice,
          bagCount: innerBagDetail.quantity,
          bagRemark: item.innerBag.remark,
          boxMethod: item.innerBox.desc,
          boxProvider: item.innerBox.provider,
          boxQty: item.innerBox.itemsPerPack,
          boxNeutralSize: innerBoxDetail.supplierDimension,
          boxUseSize: innerBoxDetail.actualDimension,
          boxCode: innerBoxDetail.code,
          boxName: innerBoxDetail.name,
          boxSpec: innerBoxDetail.specification,
          boxPrice: innerBoxDetail.unitPrice,
          boxCount: innerBoxDetail.quantity,
          boxRemark: item.innerBox.remark,
          baseMerge: baseMerge,
          bagMerge: bagMerge,
          boxMerge: boxMerge,
        };
        tableData.push(data);
      }
    }
    return tableData;
  }

  // 合并单元格
  private objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    if (columnIndex <= 6 || (columnIndex >= 14 && columnIndex <= 17) || columnIndex >= 25) {
      return { rowspan: row.baseMerge, colspan: 1 }
    }
    if (columnIndex >= 7 && columnIndex <= 13) {
      return { rowspan: row.bagMerge, colspan: 1 }
    }
    if (columnIndex >= 18 && columnIndex <= 24) {
      return { rowspan: row.boxMerge, colspan: 1 }
    }
    return { rowspan: 1, colspan: 1 }
  }

  // 表头样式
  private headerCellStyle({ row, column, rowIndex, columnIndex }) {
    if (rowIndex === 0) {
      // 内袋子表头 - 蓝色背景
      if (columnIndex === 4) {
        return { backgroundColor: '#409EFF', color: '#fff', fontWeight: 'bold' }
      }
      // 内盒子表头 - 橙色背景
      if (columnIndex === 5) {
        return { backgroundColor: '#E6A23C', color: '#fff', fontWeight: 'bold' }
      }
    }
    return {}
  }

  // 单元格样式
  private cellStyle({ row, column, rowIndex, columnIndex }) {
    // 尼龙袋子列样式
    if (columnIndex >= 4 && columnIndex <= 14) {
      return { backgroundColor: '#E8F4FF' }
    }

    // 内盒子列样式
    if (columnIndex >= 15 && columnIndex <= 25) {
      return { backgroundColor: '#FFF3E6' }
    }
  }

  //编辑
  private edit(row) {
    const filter = this.queryList.filter(item => item.id === row.id)[0];
    const data = deepClone(filter);
    (this.$refs['editPackage'] as EditPackage).openDialog(data);
  }

  private async downloadTemplate() {
    await downloadTemplate();
  }

  private async download() {
    const params = {
      brandId: this.headerInfo.brandId,
      inquiryRefNumber: this.searchParams.inquiryRefNumber,
      supplier: this.searchParams.supplier,
    }
    await downloadInfo(params);
  }

  private addFile(file: any) {
    if (file.size / 1024 / 1024 >= 10) {
      Message({
        message: "上传的文件大小不能超过10M!",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.files.push(file);
  }

  private async handleUpload() {
    if (this.files.length == 0) {
      return;
    }
    this.containerLoading = true;
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    await uploadCustomerPackage({brandId: this.headerInfo.brandId}, formData)
        .then(() => {
          this.$notify({
            title: "成功",
            message: "上传成功",
            type: "success",
            duration: 2000,
          });
          this.getList();
        })
        .finally(() => {
          this.containerLoading = false;
          this.files = [];
        });
  }

  private handleDelete(row) {
    const message = "是否删除品名【" + row.hqName + "】" + "号码【" + row.code + "】供应商【" + row.supplier + "】的包装"
    this.$confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deletePackaging({ profileId: row.id }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.getList();
      });
    })
  }

  private clear() {
    this.$confirm('清空将删除此品牌全部数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      await purgeAllPackagingByBrand({brandId: this.headerInfo.brandId});
      this.$message({
        type: 'success',
        message: '清空成功!'
      });
      await this.getList();
    })
  }
}
